<template>
  <div>
    <a-drawer
      :title="(action == 'add' ? '添加' : '更新') + '任务'"
      :width="400"
      :visible="visible"
      @close="
        $emit('update:visible', false);
        form.resetFields();
      "
    >
      <a-form
        :form="form"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16 }"
        @submit="handleOk"
      >
        <a-form-item label="id" v-show="false">
          <a-input v-decorator="['id']"> </a-input>
        </a-form-item>
        <a-form-item label="站点名称">
          <a-select
            :disabled="action == 'add' ? false : true"
            v-decorator="[
              'station_id',
              {
                initialValue: '',
                rules: [{ required: true, message: '请选择站点名称' }]
              }
            ]"
            placeholder="请选择站点名称"
            option-filter-prop="children"
            showSearch
            filterOption
          >
            <a-select-option
              v-for="item in stationList"
              :key="item.station_id"
              :value="item.station_id"
            >
              {{ item.station_name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="运维人员">
          <a-select
            mode="multiple"
            v-decorator="[
              'ops_user_ids',
              {
                initialValue: [],
                rules: [{ required: true, message: '请选择运维人员' }]
              }
            ]"
            placeholder="请选择运维人员"
            option-filter-prop="children"
            showSearch
          >
            <a-select-option
              v-for="item in operationUserList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="任务类型" v-if="action == 'add'">
          <a-select
            v-decorator="[
              'task_type_id',
              {
                rules: [{ required: true, message: '请选择任务类型' }]
              }
            ]"
            placeholder="请选择任务类型"
          >
            <a-select-option
              v-for="item in taskTypeList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="描述">
          <a-textarea
            v-decorator="[
              'comment',
              {
                rules: [{ required: true, message: '请输入描述' }]
              }
            ]"
            placeholder="请输入描述"
          />
        </a-form-item>
      </a-form>

      <div class="drawer-btn">
        <a-button
          :style="{ marginRight: '8px' }"
          @click="
            $emit('update:visible', false);
            form.resetFields();
          "
        >
          取消
        </a-button>
        <a-button type="primary" @click="handleOk">
          确定
        </a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { addOperationTask } from "@/api/api";

export default {
  data() {
    return {
      form: this.$form.createForm(this)
    };
  },
  props: {
    action: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    },
    record: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState([
      "authUserInfo",
      "stationList",
      "taskTypeList",
      "operationUserList"
    ]),
    ...mapGetters(["defaultInfo"])
  },
  watch: {
    visible() {
      if (this.action == "edit") {
        this.updateCurTask();
      }
    }
  },
  methods: {
    handleOk() {
      this.form.validateFields(async (err, values) => {
        if (err) return;
        let p = addOperationTask;
        const params = {
          group_id: this.defaultInfo.defaultGroupId,
          ops_user_ids: values.ops_user_ids,
          station_id: values.station_id,
          task_type_id: values.task_type_id,
          comment: values.comment
        };
        // if (this.action == "add") {
        //   p = addOperationTask;
        // }

        try {
          let res = await p(params);
          this.form.resetFields();
          this.$message.success(res.data.msg);
          this.$emit("onOk", false);
        } catch (error) {
          this.$emit("update:visible", false);
          console.log(error);
        }
      });
    },
    updateCurTask() {
      const editFields = ["id", "station_id"];
      editFields.forEach(v => this.form.getFieldDecorator(v));
      const form_ = {};
      form_["id"] = this.record["id"];
      form_["station_id"] = this.record["station_id"];
      this.$nextTick(() => {
        this.form.setFieldsValue(form_);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.drawer-btn {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}
/deep/ .ant-upload-list-picture-card .ant-upload-list-item {
  padding: 0;
}
</style>
